import { styled } from '../../styled';
export var StackLayoutItemComponentName = 'QuantumStackLayoutItem';
export var StackLayoutItem = styled('div', {
    name: StackLayoutItemComponentName,
    slot: 'Root',
})({
    maxWidth: '100%',
});
